<template>
  <div class="outline-container">
    <!-- 查询与统计栏目卡片 -->
    <el-card class="filter-card">
      <div class="filter-container">
        <!-- 左侧查询表单 -->
        <div class="left-section">
          <el-form :inline="true" :model="filterForm" class="filter-form" size="small">
            <div class="form-content">
              <!-- 级别选择 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.level"
                  multiple
                  collapse-tags
                  placeholder="级别"
                  style="width: 150px">
                  <el-option
                    v-for="item in levelOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 一级大纲 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.outline_l1"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="一级大纲"
                  style="width: 180px">
                  <el-option
                    v-for="item in outlineL1Options"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 二级大纲 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.outline_l2"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="二级大纲"
                  style="width: 180px">
                  <el-option
                    v-for="item in outlineL2Options"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 三级大纲 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.outline_l3"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="三级大纲"
                  style="width: 180px">
                  <el-option
                    v-for="item in outlineL3Options"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 掌握程度 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.status"
                  multiple
                  collapse-tags
                  placeholder="掌握程度"
                  style="width: 150px">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item class="filter-buttons">
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleSearch">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 右侧数据展示 -->
        <div class="right-section">
          <!-- 显示所有进度按钮 -->
          <div class="stat-action">
            <el-tooltip content="显示所有进度" placement="top">
              <el-button
                type="text"
                icon="el-icon-data-analysis"
                @click="showDetailStatistics">
              </el-button>
            </el-tooltip>
          </div>

          <!-- 入门级 -->
          <div class="stat-card">
            <div class="stat-value">{{ statistics.basic !== undefined ? statistics.basic.toFixed(2) : '0.00' }}%</div>
            <div class="stat-label">入门级</div>
            <div class="progress-outer">
              <div 
                class="progress-inner" 
                :style="{ width: (statistics.basic || 0) + '%', backgroundColor: '#67C23A' }">
              </div>
            </div>
          </div>

          <!-- 提高级 -->
          <div class="stat-card">
            <div class="stat-value">{{ statistics.advanced !== undefined ? statistics.advanced.toFixed(2) : '0.00' }}%</div>
            <div class="stat-label">提高级</div>
            <div class="progress-outer">
              <div 
                class="progress-inner" 
                :style="{ width: (statistics.advanced || 0) + '%', backgroundColor: '#409EFF' }">
              </div>
            </div>
          </div>
          
          <!-- NOI级 -->
          <div class="stat-card">
            <div class="stat-value">{{ statistics.noi !== undefined ? statistics.noi.toFixed(2) : '0.00' }}%</div>
            <div class="stat-label">NOI 级</div>
            <div class="progress-outer">
              <div 
                class="progress-inner" 
                :style="{ width: (statistics.noi || 0) + '%', backgroundColor: '#8E44AD' }">
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 数据表格卡片 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="outlineList"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#f2f3f5',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px',
          height: '52px',
          padding: '0'
        }"
        @sort-change="handleSortChange">
        
        <!-- 序号列 -->
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <!-- 级别 -->
        <el-table-column
          prop="level"
          label="级别"
          sortable="custom"
          width="100">
          <template slot-scope="{row}">
            <span
              class="level-tag"
              :class="{
                'entry-level': row.level === '入门级',
                'advanced-level': row.level === '提高级',
                'noi-level': row.level === 'NOI 级'
              }">
              {{ row.level }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 一级大纲 -->
        <el-table-column
          prop="outline_l1"
          label="一级大纲"
          sortable="custom"
          show-overflow-tooltip
          min-width="120">
        </el-table-column>
        
        <!-- 二级大纲 -->
        <el-table-column
          prop="outline_l2"
          label="二级大纲"
          sortable="custom"
          show-overflow-tooltip
          min-width="120">
        </el-table-column>
        
        <!-- 三级大纲 -->
        <el-table-column
          prop="outline_l3"
          label="三级大纲"
          sortable="custom"
          show-overflow-tooltip
          min-width="180">
        </el-table-column>
        
        <!-- 难度系数 -->
        <el-table-column
          prop="cod"
          label="难度系数"
          sortable="custom"
          width="180"
          align="center">
          <template slot-scope="{row}">
            <el-rate
              :value="row.cod"
              disabled
              :max="10"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              text-color="#ff9900"
              score-template="{value}">
            </el-rate>
          </template>
        </el-table-column>
        
        <!-- 掌握程度 -->
        <el-table-column
          prop="status"
          label="掌握程度"
          sortable="custom"
          width="140"
          align="center">
          <template slot-scope="{row}">
            <div class="status-display">
              <el-tag
                :type="getStatusTagType(row.status)"
                :class="[
                  'status-tag',
                  row.status === 4 ? 'mastered-tag' : '',
                  row.status === 0 ? 'unknown-tag' : '',
                  row.status === 1 ? 'aware-tag' : '', 
                  row.status === 2 ? 'understand-tag' : '',
                  row.status === 3 ? 'apply-tag' : '',
                  row.status === 99 ? 'undefined-tag' : ''
                ]"
                size="small"
                @click="showStatusSelect(row)">
                {{ getStatusLabel(row.status) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        
        <!-- 更新时间 -->
        <el-table-column
          prop="update_time"
          label="更新时间"
          sortable="custom"
          width="165"
          align="center">
          <template slot-scope="{row}">
            {{ row.update_time }}
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 - 移动到表格卡片内部 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 版权信息卡片 -->
    <el-card class="copyright-card">
      <div class="copyright-content">
        <span>Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1</span>
      </div>
    </el-card>

    <!-- 状态选择对话框 -->
    <div class="vertical-center-dialog" :style="{ zIndex: 2001, display: statusDialogVisible ? 'block' : 'none' }">
      <el-dialog
        title="选择掌握程度"
        :visible.sync="statusDialogVisible"
        width="600px"
        :show-close="false"
        :append-to-body="false"
        :modal-append-to-body="false"
        :destroy-on-close="true"
        custom-class="status-dialog">
        <div class="status-options">
          <el-radio-group v-model="tempStatus" class="status-radio-group">
            <el-radio 
              v-for="item in statusOptions" 
              :key="item.value" 
              :label="item.value" 
              class="status-radio-item">
              <div
                :class="[
                  'custom-tag',
                  item.value === 4 ? 'mastered' : '',
                  item.value === 0 ? 'unknown' : '',
                  item.value === 1 ? 'aware' : '', 
                  item.value === 2 ? 'understand' : '',
                  item.value === 3 ? 'apply' : '',
                  item.value === 99 ? 'undefined' : ''
                ]">
                {{ item.label }}
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmStatusChange">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 详细统计弹窗 -->
    <div class="vertical-center-dialog" :style="{ zIndex: 2001, display: detailStatisticsVisible ? 'block' : 'none' }">
      <el-dialog
        title="大纲掌握进度详情"
        :visible.sync="detailStatisticsVisible"
        width="800px"
        :append-to-body="false"
        :modal-append-to-body="false"
        class="outline-stats-dialog"
        custom-class="detail-statistics-dialog">
        <div class="statistics-content">
          <el-table
            :data="detailStatistics"
            style="width: 100%"
            :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              fontWeight: '600',
              fontSize: '14px',
              height: '52px',
              padding: '0'
            }">
            <el-table-column
              prop="level"
              label="级别"
              width="120">
              <template slot-scope="{row}">
                <span
                  :class="[
                    'custom-level-tag',
                    row.level === '入门级' ? 'entry-level-tag' : '',
                    row.level === '提高级' ? 'advanced-level-tag' : '',
                    row.level === 'NOI 级' ? 'noi-level-tag' : ''
                  ]">
                  {{ row.level }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="outline_l1"
              label="一级大纲"
              min-width="240">
            </el-table-column>
            <el-table-column
              prop="mastery_percent"
              label="掌握度"
              width="240"
              align="center">
              <template slot-scope="{row}">
                <div class="progress-cell">
                  <div class="progress-bar">
                    <div 
                      class="progress-inner"
                      :style="{ 
                        width: row.mastery_percent + '%',
                        backgroundColor: getProgressColor(row.level)
                      }">
                    </div>
                  </div>
                  <span class="progress-value">{{ Number(row.mastery_percent).toFixed(2) }}%</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getOutlineList, getOutlineStatistics, getOutlineDetailStatistics, updateOutlineStatus, getOutlineStatusOptions, getOutlineLevelOptions } from '@/api/outline'

export default {
  name: 'Outline',
  data() {
    return {
      loading: false,
      outlineList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      sortProp: 'id',
      sortOrder: 'ascending',
      
      filterForm: {
        level: [],
        outline_l1: [],
        outline_l2: [],
        outline_l3: [],
        status: []
      },
      
      // 各选项列表
      levelOptions: [],
      outlineL1Options: [],
      outlineL2Options: [],
      outlineL3Options: [],
      statusOptions: [
        { value: 99, label: '未定义' },
        { value: 0, label: '未知' },
        { value: 1, label: '了解' },
        { value: 2, label: '理解' },
        { value: 3, label: '应用' },
        { value: 4, label: '掌握' }
      ],
      
      // 统计数据
      statistics: {
        basic: 0,     // 入门级掌握程度
        advanced: 0,  // 提高级掌握程度
        noi: 0        // NOI级掌握程度
      },

      statusDialogVisible: false,
      tempStatus: null,
      currentRow: null,
      detailStatisticsVisible: false,
      detailStatistics: []
    }
  },
  computed: {
    groupedStatistics() {
      const groups = {}
      this.detailStatistics.forEach(item => {
        if (!groups[item.level]) {
          groups[item.level] = []
        }
        groups[item.level].push(item)
      })
      return groups
    }
  },
  created() {
    this.fetchData()
    this.fetchStatistics()
    this.fetchLevelOptions() // 获取级别选项
    this.fetchAllOutlineOptions() // 获取所有大纲选项
  },
  methods: {
    async fetchData(filterParams = {}) {
      this.loading = true
      try {
        // 构建请求参数，始终包含排序和分页参数
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          sort_prop: this.sortProp,
          sort_order: this.sortOrder,
          ...filterParams
        }
        
        console.log('fetchData - 当前页码:', this.currentPage)
        console.log('fetchData - 每页条数:', this.pageSize)
        console.log('fetchData - 筛选条件:', filterParams)
        console.log('fetchData - 最终请求参数:', params)
        
        const response = await getOutlineList(params)
        console.log('fetchData - 返回的数据:', response)
        
        // 检查并处理返回的数据
        if (response && response.code === 200 && response.data) {
          this.outlineList = response.data.items || []
          this.total = response.data.total || 0
          
          console.log('fetchData - 处理后的数据:', {
            items: this.outlineList.length,
            total: this.total,
            currentPage: this.currentPage,
            pageSize: this.pageSize
          })
          
          // 如果是首次加载或没有选项数据，从返回的数据中提取
          if (this.outlineL1Options.length === 0 || this.outlineL2Options.length === 0 || this.outlineL3Options.length === 0) {
            this.extractOutlineOptions()
          }
        } else {
          console.error('返回数据格式不正确:', response)
          this.outlineList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取大纲列表失败:', error)
        this.$message.error('获取大纲列表失败')
        this.outlineList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    async fetchStatistics() {
      try {
        const response = await getOutlineStatistics()
        if (response && response.code === 200 && response.data) {
          this.statistics = {
            basic: response.data.basic || 0,
            advanced: response.data.advanced || 0,
            noi: response.data.noi || 0
          }
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    
    // 获取级别选项
    async fetchLevelOptions() {
      try {
        const response = await getOutlineLevelOptions()
        if (response && response.code === 200 && response.data) {
          this.levelOptions = response.data || []
        }
      } catch (error) {
        console.error('获取级别选项失败:', error)
      }
    },
    
    // 获取所有大纲选项
    async fetchAllOutlineOptions() {
      try {
        // 获取所有数据（尺寸很大，只用于提取选项）
        const params = {
          pageNum: 1,
          pageSize: 1000, // 获取大量数据以提取所有可能的选项
          sort_prop: 'id',
          sort_order: 'ascending'
        }
        
        const response = await getOutlineList(params)
        if (response && response.code === 200 && response.data && response.data.items) {
          this.processOutlineOptions(response.data.items)
        } else {
          // 降级：使用当前页数据
          this.extractOutlineOptions()
        }
      } catch (error) {
        console.error('获取所有大纲选项失败:', error)
        // 降级：使用当前页数据
        this.extractOutlineOptions()
      }
    },
    
    // 处理大纲选项数据
    processOutlineOptions(data) {
      // 提取一级大纲选项（去重）
      const l1Set = new Set(data.map(item => item.outline_l1))
      this.outlineL1Options = Array.from(l1Set).filter(Boolean).sort()
      
      // 提取二级大纲选项（去重）
      const l2Set = new Set(data.map(item => item.outline_l2))
      this.outlineL2Options = Array.from(l2Set).filter(Boolean).sort()
      
      // 提取三级大纲选项（去重）
      const l3Set = new Set(data.map(item => item.outline_l3))
      this.outlineL3Options = Array.from(l3Set).filter(Boolean).sort()
    },
    
    // 从当前数据中提取大纲选项（降级方案）
    extractOutlineOptions() {
      // 提取一级大纲选项（去重）
      const l1Set = new Set(this.outlineList.map(item => item.outline_l1))
      this.outlineL1Options = Array.from(l1Set).filter(Boolean).sort()
      
      // 提取二级大纲选项（去重）
      const l2Set = new Set(this.outlineList.map(item => item.outline_l2))
      this.outlineL2Options = Array.from(l2Set).filter(Boolean).sort()
      
      // 提取三级大纲选项（去重）
      const l3Set = new Set(this.outlineList.map(item => item.outline_l3))
      this.outlineL3Options = Array.from(l3Set).filter(Boolean).sort()
    },
    
    handleSearch() {
      // 重置页码
      this.currentPage = 1
      // 保持排序状态，传入当前筛选条件
      this.fetchData(this.filterForm)
    },
    
    handleReset() {
      // 重置筛选条件
      this.filterForm = {
        level: [],
        outline_l1: [],
        outline_l2: [],
        outline_l3: [],
        status: []
      }
      
      // 重置页码，并恢复默认排序
      this.currentPage = 1
      this.sortProp = 'id'
      this.sortOrder = 'ascending'
      
      // 重新获取数据
      this.fetchData()
    },
    
    handleSortChange({ prop, order }) {
      console.log('排序变化 - 原始参数:', { prop, order })
      
      // 更新排序状态
      if (!order) {
        // 取消排序时，恢复默认排序
        this.sortProp = 'id'
        this.sortOrder = 'ascending'
      } else {
        // 直接使用 Element UI 的排序值
        this.sortProp = prop
        this.sortOrder = order
      }
      
      // 获取当前的筛选条件并发送请求
      const params = {
        ...this.filterForm,
        sort_prop: this.sortProp,
        sort_order: this.sortOrder
      }
      
      // 添加调试日志
      console.log('排序变化 - 发送的参数:', {
        prop: this.sortProp,
        order: this.sortOrder,
        params
      })
      
      this.fetchData(params)
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      // 使用当前的筛选条件重新获取数据
      this.fetchData(this.filterForm)
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      // 使用当前的筛选条件重新获取数据
      this.fetchData(this.filterForm)
    },
    
    async handleStatusChange(row) {
      try {
        // 显示确认提示
        await this.$confirm(`确认将掌握程度修改为"${this.getStatusLabel(row.status)}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 调用接口更新状态
        await updateOutlineStatus(row.id, row.status)
        this.$message.success('更新掌握程度成功')
        
        // 刷新统计数据
        this.fetchStatistics()
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消，恢复原始状态
          this.fetchData(this.filterForm)
        } else {
          console.error('更新掌握程度失败:', error)
          this.$message.error('更新掌握程度失败')
          
          // 回滚到原来的状态
          this.fetchData(this.filterForm)
        }
      }
    },
    
    // 获取掌握程度标签文字
    getStatusLabel(status) {
      const statusItem = this.statusOptions.find(item => item.value === status)
      return statusItem ? statusItem.label : '未知'
    },
    
    // 根据级别获取标签类型
    getLevelTagType(level) {
      // 不再使用类型，完全通过class控制样式
      return '';
    },
    
    // 根据掌握程度获取标签类型
    getStatusTagType(status) {
      const typeMap = {
        99: 'info',    // 未定义
        0: 'danger',   // 未知
        1: 'warning',  // 了解
        2: 'success',  // 理解 - 绿色
        3: 'primary',  // 应用 - 蓝色
        4: ''          // 掌握 - 紫色（使用自定义样式）
      }
      return typeMap[status] || 'info'
    },
    
    showStatusSelect(row) {
      this.tempStatus = row.status
      this.currentRow = row
      this.statusDialogVisible = true
    },

    confirmStatusChange() {
      if (!this.currentRow) return
      
      // 获取当前选中的状态值
      const newStatus = this.tempStatus
      this.statusDialogVisible = false
      
      // 更新当前行状态
      this.currentRow.status = newStatus
      
      // 调用状态修改方法
      this.handleStatusChange(this.currentRow)
      
      // 重置临时变量
      this.currentRow = null
      this.tempStatus = null
    },

    async showDetailStatistics() {
      try {
        const response = await getOutlineDetailStatistics()
        if (response && response.code === 200 && response.data) {
          this.detailStatistics = response.data
          this.detailStatisticsVisible = true
          
          // 设置合适的表格高度
          this.$nextTick(() => {
            const tableHeight = this.getTableHeight()
            if (tableHeight) {
              const tableEl = document.querySelector('.detail-statistics-dialog .el-table')
              if (tableEl) {
                tableEl.style.height = tableHeight + 'px'
              }
            }
          })
        }
      } catch (error) {
        console.error('获取详细统计数据失败:', error)
        this.$message.error('获取详细统计数据失败')
      }
    },

    // 根据数据计算合适的表格高度
    getTableHeight() {
      const rowCount = this.detailStatistics.length
      // 默认每行高度约为 48px，表头约 44px
      const rowHeight = 48
      const headerHeight = 44
      
      // 根据行数直接计算实际高度，不再增加额外空间
      // 如果行数很少，保持一个最小高度
      if (rowCount <= 3) {
        return headerHeight + (rowCount * rowHeight) * 1.2 // 仅增加20%空间给少量数据
      }
      
      // 如果行数适中，计算实际所需高度，稍微紧凑一点
      if (rowCount <= 10) {
        return headerHeight + (rowCount * rowHeight)
      }
      
      // 如果行数较多，限制高度，最大显示约15行，避免过高
      const maxRows = Math.min(rowCount, 15)
      return headerHeight + (maxRows * rowHeight)
    },

    getProgressColor(level) {
      const colorMap = {
        '入门级': '#67C23A',  // 绿色
        '提高级': '#409EFF',  // 蓝色
        'NOI 级': '#8E44AD'   // 紫色
      }
      return colorMap[level] || '#909399'
    }
  }
}
</script>

<style lang="scss" scoped>
.outline-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  
  .filter-card {
    margin: 8px 0 0 0;
    flex-shrink: 0;
    background-color: #fff;
    position: relative;
    z-index: 10;
    height: 72px;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
  }
  
  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 16px;

    .left-section {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-right: 20px;
      flex-shrink: 1;
      overflow-x: auto;
      height: 100%;
      
      .filter-form {
        display: flex;
        align-items: center;
        white-space: nowrap;
        height: 100%;
        
        .form-content {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 100%;
          
          :deep(.el-input),
          :deep(.el-select) {
            .el-input__inner {
              height: 32px;
              line-height: 32px;
              font-size: 13px;
            }
          }
          
          :deep(.el-button) {
            height: 32px;
            line-height: 30px;
            padding: 0 16px;
            font-size: 13px;
          }
          
          .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
            display: flex;
            align-items: center;
          }

          .filter-buttons {
            margin-left: auto;
            white-space: nowrap;
            
            .el-button + .el-button {
              margin-left: 8px;
            }
          }
        }
      }
    }

    .right-section {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
      padding: 0 12px;
      background-color: #f6f8fa;
      border-radius: 8px;
      height: 52px;
      
      .stat-action {
        display: flex;
        align-items: center;
        padding-right: 8px;
        
        .el-button {
          padding: 0;
          font-size: 20px;
          color: #606266;
          
          &:hover {
            color: #409EFF;
          }
        }
      }
      
      .stat-card {
        text-align: center;
        min-width: 80px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        padding: 0 10px;

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          right: -8px;
          top: 50%;
          transform: translateY(-50%);
          height: 36px;
          width: 1px;
          background-color: #dcdfe6;
        }

        .stat-value {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 12px;
          color: #6b7280;
          line-height: 1;
          margin-bottom: 6px;
        }
        
        .progress-outer {
          width: 100%;
          height: 4px;
          background-color: #ebeef5;
          border-radius: 2px;
          overflow: hidden;
          
          .progress-inner {
            height: 100%;
            transition: width 0.6s ease;
          }
        }
      }
    }
  }
  
  .table-card {
    margin: 8px 0 0 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    min-height: 0;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    :deep(.el-table) {
      flex: 1;
      height: 100%;
      
      .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #fff;
      }
      
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 60px);
      }
      
      th {
        background-color: #f2f3f5;
        color: #606266;
        font-weight: 600;
        font-size: 14px;
        height: 52px;
        padding: 0;
        border-bottom: 1px solid #ebeef5;
      }
      
      td {
        padding: 8px 0;
        border-bottom: 1px solid #ebeef5;
      }

      .el-table__row {
        height: 52px;
      }
      
      .el-rate {
        height: 20px;
        line-height: 1;
        display: inline-flex;
        
        .el-rate__icon {
          font-size: 12px;
          margin-right: 2px;
        }
      }

      .el-tag {
        &.el-tag--success {
          background-color: #67C23A;
          border-color: #67C23A;
          color: white;
        }
        
        &.el-tag--primary {
          background-color: #409EFF;
          border-color: #409EFF;
          color: white;
        }
        
        &.noi-tag {
          background-color: #8E44AD !important;
          border-color: #8E44AD !important;
          color: white !important;
        }
      }
    }
  }
  
  .pagination-container {
    height: 40px;
    padding: 0 16px;
    background-color: #fff;
    border-top: 1px solid #e4e7ed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
  }
  
  .copyright-card {
    margin: 8px 0;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 4px;
    height: 40px;
    position: relative;
    z-index: 1;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
    
    .copyright-content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      font-size: 14px;
      
      span {
        line-height: 1;
      }
    }
  }

  .status-dialog {
    .el-dialog__body {
      padding: 25px 15px !important;
    }

    .status-options {
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 10px 0;
    }

    .status-radio-group {
      display: flex !important;
      flex-direction: row !important;
      justify-content: space-around !important;
      align-items: center !important;
      width: 100% !important;
    }

    .status-radio-item {
      margin: 0 !important;
      flex: 0 0 auto !important;
      display: flex !important;
      justify-content: center !important;
    }

    .el-radio {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      margin-right: 0 !important;
      padding: 12px 8px !important;
      border-radius: 6px !important;
      transition: all 0.3s !important;
      
      &:hover {
        background-color: #f5f7fa !important;
      }
      
      &.is-checked {
        background-color: #ecf5ff !important;
      }

      .el-radio__input {
        margin-bottom: 12px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        
        .el-radio__inner {
          margin: 0 auto !important;
        }
      }

      .el-radio__label {
        padding-left: 0 !important;
        color: #606266 !important;
        font-size: 14px !important;
        margin-top: 0 !important;
        display: none !important;
      }

      .custom-tag {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 40px !important;
        height: 25px !important;
        border-radius: 4px !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        color: white !important;
        text-align: center !important;
        border: 1px solid transparent !important;
        margin: 0 auto !important;

        &.mastered {
          background-color: #8E44AD !important;
          border-color: #8E44AD !important;
        }
        
        &.understand {
          background-color: #67C23A !important;
          border-color: #67C23A !important;
        }
        
        &.apply {
          background-color: #409EFF !important;
          border-color: #409EFF !important;
        }
        
        &.unknown {
          background-color: #F56C6C !important;
          border-color: #F56C6C !important;
        }
        
        &.aware {
          background-color: #E6A23C !important;
          border-color: #E6A23C !important;
        }
        
        &.undefined {
          background-color: #909399 !important;
          border-color: #909399 !important;
        }
      }
    }
  }

  :deep(.el-tag) {
    &.mastered-tag {
      background-color: #8E44AD !important;
      border-color: #8E44AD !important;
      color: white !important;
    }
    
    &.understand-tag {
      background-color: #67C23A !important;
      border-color: #67C23A !important;
      color: white !important;
    }
    
    &.apply-tag {
      background-color: #409EFF !important;
      border-color: #409EFF !important;
      color: white !important;
    }
    
    &.unknown-tag {
      background-color: #F56C6C !important;
      border-color: #F56C6C !important;
      color: white !important;
    }
    
    &.aware-tag {
      background-color: #E6A23C !important;
      border-color: #E6A23C !important;
      color: white !important;
    }
    
    &.undefined-tag {
      background-color: #909399 !important;
      border-color: #909399 !important;
      color: white !important;
    }

    &.noi-tag {
      background-color: #8E44AD !important;
      border-color: #8E44AD !important;
      color: white !important;
      width: 40px;
      text-align: center;
      display: inline-flex;
      justify-content: center;
    }
    
    &.entry-tag {
      background-color: #67C23A !important;
      border-color: #67C23A !important;
      color: white !important;
      width: 40px;
      text-align: center;
      display: inline-flex;
      justify-content: center;
    }
    
    &.advanced-tag {
      background-color: #409EFF !important;
      border-color: #409EFF !important;
      color: white !important;
      width: 40px;
      text-align: center;
      display: inline-flex;
      justify-content: center;
    }
  }

  .status-tag {
    width: 40px;
    text-align: center;
    padding: 5px 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    cursor: pointer;
    height: 28px;
    
    &:hover {
      opacity: 0.8;
    }
  }

  .level-tag {
    display: inline-block;
    height: 28px;
    line-height: 28px;
    padding: 0 8px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    color: white;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid transparent;
  }

  .entry-level {
    background-color: #67C23A;
    border-color: #67C23A;
  }
  
  .advanced-level {
    background-color: #409EFF;
    border-color: #409EFF;
  }
  
  .noi-level {
    background-color: #8E44AD;
    border-color: #8E44AD;
  }
}

/* 大纲掌握进度详情对话框样式 */
:deep(.detail-statistics-dialog) {
  .el-dialog__header {
    padding: 15px 20px;
  }
  
  .el-dialog__body {
    padding: 10px 20px 20px;
  }

  .statistics-content {
    padding-top: 5px;
    
    .el-table {
      border: none;
      
      td {
        padding: 8px 0;
      }

      .el-tag {
        font-size: 12px;
      }
    }
    
    /* 进度条相关样式 */
    .progress-cell {
      display: flex;
      align-items: center;
      
      .progress-bar {
        flex: 1;
        height: 10px;
        background-color: #ebeef5;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 12px;
        
        .progress-inner {
          height: 100%;
          transition: width 0.6s ease;
        }
      }
      
      .progress-value {
        width: 70px;
        text-align: right;
        font-weight: bold;
        font-size: 14px;
        color: #333;
      }
    }

    /* 自定义标签样式 */
    .custom-level-tag {
      display: inline-block;
      padding: 0 8px;
      height: 28px;
      line-height: 28px;
      font-size: 13px;
      border-radius: 4px;
      color: white;
      width: 70px;
      text-align: center;
      white-space: nowrap;
      font-weight: 500;
    }
    
    .entry-level-tag {
      background-color: #67C23A;
      border-color: #67C23A;
    }
    
    .advanced-level-tag {
      background-color: #409EFF;
      border-color: #409EFF;
    }
    
    .noi-level-tag {
      background-color: #8E44AD;
      border-color: #8E44AD;
    }

    /* 为方便调试 - 元素标签样式 */
    .el-tag.entry-tag {
      background-color: #67C23A !important;
      border-color: #67C23A !important;
      color: white !important;
      width: 40px !important;
      text-align: center !important;
      display: inline-flex !important;
      justify-content: center !important;
      padding: 0 5px !important;
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 4px !important;
      font-size: 13px !important;
    }
    
    .el-tag.advanced-tag {
      background-color: #409EFF !important;
      border-color: #409EFF !important;
      color: white !important;
      width: 40px !important;
      text-align: center !important;
      display: inline-flex !important;
      justify-content: center !important;
      padding: 0 5px !important;
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 4px !important;
      font-size: 13px !important;
    }
    
    .el-tag.noi-tag {
      background-color: #8E44AD !important;
      border-color: #8E44AD !important;
      color: white !important;
      width: 40px !important;
      text-align: center !important;
      display: inline-flex !important;
      justify-content: center !important;
      padding: 0 5px !important;
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 4px !important;
      font-size: 13px !important;
    }
  }
}

/* 垂直居中对话框样式 */
::v-deep .vertical-center-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
  pointer-events: none; /* 默认不接收鼠标事件 */
  display: flex;
  justify-content: center;
  align-items: center; /* 保持居中 */
  
  .el-dialog__wrapper {
    pointer-events: auto; /* 对话框本身接收鼠标事件 */
    position: relative !important;
    margin: 0 auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .el-dialog {
    margin: 0 auto !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    transform: translateY(-10vh) !important; /* 只对弹窗本身向上偏移 */
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    height: auto;
    max-height: none !important;
    overflow: hidden;
  }
  
  .el-dialog__body {
    overflow: hidden;
    flex: 1;
  }
}

.outline-stats-dialog {
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
  }
  
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
  }
  
  .el-table__body-wrapper::-webkit-scrollbar-track {
    background: #f5f7fa;
  }
}

/* 简单修复状态选择对话框样式 */
.status-dialog .el-radio {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}

.status-dialog .el-radio .el-radio__input {
  margin-bottom: 12px !important;
  display: flex !important;
  justify-content: center !important;
}

.status-dialog .el-radio .custom-tag {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style> 